export default __webpack_public_path__ + "static/media/betslip-astronaut.04cc77f8.png";